import React from 'react';
import PropTypes from 'prop-types';
import {
	useLabels,
	useSitemap,
	useRequestData,
	usePrefs
} from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';

import { getHtmlWithDLData } from '../utils/labelHelper';
import { getClassesForLink } from '../utils/getClassesForLink';
import { setUrl } from '../utils/linkHelper';

const MoreAboutDealer = ({ totalCount }) => {
	const sitemap = useSitemap();
	const labels = useLabels();
	const { deviceType } = useRequestData();
	const isMobile = deviceType !== 'DESKTOP';
	const classesforLink = getClassesForLink(totalCount, isMobile);
	const prefs = usePrefs();
	const linkHref = setUrl(sitemap, (prefs.ctaLink || '').trim());

	return (
		<div
			className={setClassNames([
				'why-buy-about-link',
				'd-flex',
				'flex-column',
				classesforLink
			])}
		>
			<a
				className={setClassNames([
					`btn btn-${prefs.ctaStyle}`,
					prefs.ctaClasses,
					'text-center',
					'my-auto',
					'ddc-font-size-small'
				])}
				href={linkHref}
			>
				{getHtmlWithDLData(labels.get(prefs.ctaLabel))}
			</a>
		</div>
	);
};

MoreAboutDealer.propTypes = {
	totalCount: PropTypes.number.isRequired
};

export default MoreAboutDealer;
